/* unplugin-vue-components disabled */import script from "./feedbackModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./feedbackModal.vue?vue&type=script&setup=true&lang=ts"

import "./feedbackModal.vue?vue&type=style&index=0&id=171eacbf&lang=less&scoped=true"
import "./feedbackModal.vue?vue&type=style&index=1&id=171eacbf&lang=less"

import exportComponent from "E:\\guanwnag\\hzzn.group.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-171eacbf"]])

export default __exports__